import { render, staticRenderFns } from "./TransactionViewBudget.vue?vue&type=template&id=62d10dbf&scoped=true&"
import script from "./TransactionViewBudget.vue?vue&type=script&lang=js&"
export * from "./TransactionViewBudget.vue?vue&type=script&lang=js&"
import style0 from "./TransactionViewBudget.vue?vue&type=style&index=0&id=62d10dbf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d10dbf",
  null
  
)

export default component.exports